import { FC, useState, useEffect, useRef } from 'react';
import styles from '@/styles/Ui.module.scss';
import clsx from "clsx";
import InfoIcon  from '@/svg/InfoIcon.tsx';
import WarningIcon  from '@/svg/WarningIcon.tsx';
import {notificationType} from "@/types_and_interfaces/types";
import CloseIcon from "@/svg/CloseIcon";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";

interface Props {
    message: string,
    type: notificationType,
    index: number,
    active: boolean,
    btn_text?:string
    funct?():void
}

const Item:FC<Props> = ({message, type, index, active,btn_text, funct}) => {
    
    const [hide, setHide] = useState<boolean>(false);
    const button = useRef<any>(null);
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    
    const buttonHtml = btn_text ? `<button id="button_notif" class="button_notif ${styles.button}">
        ${btn_text}
      </button>` : ""
    
    useEffect(() => {
        if(!active) {
            setTimeout(() => {
                if(debug === "true") console.info("setInterval Item")
                
                setHide(true);
            }, 10000)
            
        }
        
        let items = document.getElementsByClassName('button_notif');
        
        if (items.length > 0 && typeof funct === 'function') {
            Array.from(items).forEach(item => {
                item.addEventListener('click', funct);
            });
            
            return () => {
                Array.from(items).forEach(item => {
                    item.removeEventListener('click', funct);
                });
            };
        }
        
    },[]);
    
    if (hide) return null;
    
    return (
        <div className={clsx(
            styles.item,
            type === 'success' && styles.success,
            type === 'error' && styles.error,
            type === 'info' && styles.info,
            type === 'warning' && styles.warning
        )}>
            {type === 'info' && <InfoIcon />}
            {type === 'warning' && <WarningIcon />}
            <span dangerouslySetInnerHTML={{__html: message + " " + buttonHtml}}/>
            <button
                ref={button}
                onClick={() => {
                    eventEmitter.emit(CommonClass.CustomEvents.remove_snackbar, index)
                }}
                type={'button'}
            >
                <CloseIcon />
            </button>
        </div>
    )
}
export default Item